import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

/**
 * 検索詳細ページ　スライダー
*/
const searchDetailSlider = () => {
    // スライド要素の数をチェック
    const slideElements = document.querySelectorAll('.js_searchDetailSlider .swiper-slide');
    const galleryElement = document.querySelector('.un_searchDetail_gallery');
    
    // スライドが0枚の場合はギャラリーを非表示にする
    if (slideElements.length === 0 && galleryElement) {
        galleryElement.style.display = 'none';
        return; // スライダーを初期化しない
    }

    const swiper = new Swiper('.js_searchDetailSlider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 4000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: '.un_searchDetail_gallery .swiper-pagination',
            clickable: true,
        },
        on: {
            // ユーザーがスライダーを操作したらautoplayを停止
            touchStart: function() {
                this.autoplay.stop();
            },
            // ナビゲーションボタンがクリックされた場合
            navigationNext: function() {
                this.autoplay.stop();
            },
            navigationPrev: function() {
                this.autoplay.stop();
            },
            // ページネーションがクリックされた場合
            paginationClick: function() {
                this.autoplay.stop();
            }
        }
    });
}

export default searchDetailSlider;